import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/1b6680ef-cf12-4070-a2a2-74706422c2e7";
export const REGISTER_URL = "https://a.ntrk2.com/3266e038-ff5b-4ca7-8e40-920f82919249";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bigmx.loadprkw2a.com/download?openExternalBrowser=1&id=uf7ajd7tp28c78m";

export * from "./codes";
export * from "./context";
